import React, { useState } from 'react';

// Styles & Assets
import styles from './CalendarPage.module.css';
import { RiFilterFill } from 'react-icons/ri';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import CalendarMonth from '../../components/CalendarPage/CalendarMonth/CalendarMonth';
import CalendarWeek from '../../components/CalendarPage/CalendarWeek/CalendarWeek';
import CalendarFilterDialog from '../../components/CalendarPage/CalendarFilterDialog/CalendarFilterDialog';
import ButtonToolbar from '../../components/UI/ButtonToolbar/ButtonToolbar';
import BarArrows from '../../components/CalendarPage/BarArrows/BarArrows';
import BarButtons from '../../components/CalendarPage/BarButtons/BarButtons';

// Other
import moment from 'moment';

const CalendarPage: React.FC = () => {

    const { t } = useTranslation();

    const [referenceDate, setReferenceDate] = useState(moment());
    const [clickedDay, setClickedDay] = useState<moment.Moment | null>(null);
    const [isViewMonthly, setIsViewMonthly] = useState(true);

    const onclickDay = (d: moment.Moment) => () =>
        setClickedDay(oldDay => oldDay?.unix() !== d.unix() ? d : null);

    const handleClickToday = () => {
        const today = moment()
        setReferenceDate(today);
        setClickedDay(clickedDay =>
            clickedDay === null || !clickedDay.isSame(today, 'day') ? today : null
        );
    };

    return (
        <div className='pageContainer'>
            <Toolbar>
                <div className={styles.filterButtonContainer}>
                    <ButtonToolbar
                        icon={<RiFilterFill />}
                        label={t('filter')}
                        defaultFilterActive={true}
                    >
                        <CalendarFilterDialog modalShow={() => undefined} />
                    </ButtonToolbar>
                </div>
            </Toolbar>
            <div className={styles.calendarContainer}>
                <div className={styles.calendarBar}>
                    <BarArrows
                        isViewMonthly={isViewMonthly}
                        referenceDate={referenceDate}
                        setReferenceDate={setReferenceDate}
                    />
                    <BarButtons
                        isViewMonthly={isViewMonthly}
                        handleClickToday={handleClickToday}
                        setIsViewMonthly={setIsViewMonthly}
                    />
                </div>
                {isViewMonthly ?
                    <CalendarMonth
                        month={referenceDate.month()}
                        year={referenceDate.year()}
                        clickedDay={clickedDay}
                        onClickDay={onclickDay}
                    />
                    :
                    <CalendarWeek startDay={referenceDate.clone().startOf('isoWeek')} />
                }
            </div>
        </div>
    );
};

export default CalendarPage;

